import { Banner } from '../../../components/Banners/Banner';
import { SpeciesCard } from '../../../components/Cards/SpeciesCard/SpeciesCard';
import { ContinuousCarousel } from '../../../components/Carousels/ContinuousCarousel/ContinuousCarousel';
import { AppStoreButtons } from '../../../components/Clickables/Buttons/AppStoreButtons/AppStoreButtons';
import { Container } from '../../../components/Container/Container';
import { Heading } from '../../../components/Heading/Heading';
import { QRCode } from '../../../components/QRCode/QRCode';
import { Text } from '../../../components/Text/Text';
import { getNodesFromConnection } from '../../../helpers/graphql';
import { GetTopSpeciesNearLocation_topSpeciesNearLocation_edges } from '../../../interfaces/graphql';

interface IProps {
  id: string;
  topSpeciesEdgeList: GetTopSpeciesNearLocation_topSpeciesNearLocation_edges[];
}

export const NoSpeciesDataSection = ({ topSpeciesEdgeList, id }: IProps) => {
  return (
    <>
      <Container className="my-sm flex flex-col items-center text-center">
        <Heading variant="xl" className="w-col-4 sm:w-col-12 md:w-col-10 mb-10">
          Be the first one to log a catch for this species!
        </Heading>
        <Text className="w-col-4 sm:w-col-8 md:w-col-6">
          Download the Fishbrain app to log your catch.
        </Text>
        <div className="flex items-center justify-center gap-4">
          <QRCode className="rounded-md bg-sea-foam p-2" source="NoSpeciesDataSection" />
          <AppStoreButtons orientation="vertical" source="NoSpeciesDataSection" />
        </div>
      </Container>

      <Banner className="py-md" id="other-species-section">
        <ContinuousCarousel title="Other species near you" dataTestId="top-species">
          {topSpeciesEdgeList.map(({ catchesCount, node }, index) => {
            if (!node) {
              return <></>;
            }
            const images = getNodesFromConnection(node.exampleCatchWithImage?.post.images);
            const imageUrl = images[0]?.url || '';
            const imageWidth = images[0]?.width || 0;
            const imageHeight = images[0]?.height || 0;
            return (
              <SpeciesCard
                key={`species-${node._id}`}
                speciesId={node._id}
                name={node.displayName}
                imageUrl={imageUrl}
                imageWidth={imageWidth}
                imageHeight={imageHeight}
                clickEventPosition={index}
                clickEventSourceId={id}
                clickEventSource="species-other-top-species"
                numberCaught={catchesCount}
              />
            );
          })}
        </ContinuousCarousel>
      </Banner>
    </>
  );
};
